export enum CLOSE_BUTTONS_CONSTANT {
  HISTORY = 'history',
  CLOSE_PAGE_BUTTON = 'close',
  GO_TO_SITE_BUTTON = 'go_to_site',
  ESCAPE_KEY = 'esc_key',
  GOT_IT_BUTTON = 'got_it',
}
